import { epoch, utc } from '../../util/datetime';
import Address from '../address/Address';
import { VerificationsInterviewDetailsOption } from './VerificationsInterviewDetails.enum';
import type { IVerificationsInterviewDetails } from './VerificationsInterviewDetails.interface';

export default class VerificationsInterviewDetails implements IVerificationsInterviewDetails {
  option: VerificationsInterviewDetailsOption;
  method: string;
  address: Address;
  date: number;

  static build = (data: IVerificationsInterviewDetails) =>
    new VerificationsInterviewDetails(data);

  static blank = () => new VerificationsInterviewDetails();

  /**
   * Constructor
   * @param {IVerificationsInterviewDetails} data
   */
  constructor(data?: IVerificationsInterviewDetails) {
    this.option = VerificationsInterviewDetailsOption.of(data?.option?.name);
    this.method = data?.method || '';
    this.address = new Address(data?.address);
    this.date = data?.date ? epoch(utc(data?.date)) : 0;
  }
}
